<script>
  //import { onMount } from 'svelte';
  import { _ } from "../i18n.js";

  import { Row, Col, Container } from "sveltestrap";
  import CentralinaItem from "./CentralinaItem.svelte";

  import config from "../config.json";
  //import { mapOrder } from '../utils/utils.js';

  // ID CENTRALINE UNITO

  export let colsNumber = 1;

  const ids = Object.values(config.ids);

  let fetched;
  let isLoading = true;

  // onMount( async () => {

  //   // await fetchFromBackend(ids);
  //   //console.log("HERE")
  //   // if (fetched) {
  //   //   console.log(fetched);
  //   // }

  // })
  //fetchFromBackend(ids);
  // console.log(Object.values(config.ids))
  // console.log(ids)
  // if (fetched) {
  //   console.log(fetched);
  // }
</script>


<Row cols={colsNumber}>
  <!-- <ul>
            {#each fetched as centr }
                <li>{JSON.stringify(centr)}</li>
            {/each}
            </ul> -->
  <!-- {#if isLoading} -->
  <!-- <Col>
    <Spinner></Spinner>
  </Col> -->
  <!-- {:else if fetched} -->
  {#each ids as idTag (idTag)}
    <Col>
      <div class="item">
        <CentralinaItem {idTag} />
      </div>
    </Col>
  {/each}
  <!-- {/if} -->
</Row>

<style>
  .item {
    padding: 0.2rem;
  }
  .update {
    margin-left: 0.2rem;
    margin-right: 0.2rem;
  }
</style>
